import {
  createSlice,
  configureStore,
  combineReducers,
  AnyAction,
  Store,
} from '@reduxjs/toolkit'
import userReducer from './reducers/userReducer'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import storage from 'redux-persist/lib/storage'
import { persistCombineReducers, persistReducer, persistStore } from 'redux-persist'
import { BrowserHistory, createBrowserHistory } from 'history'
import dealershipReducer from './reducers/dealershipReducer'

const persistConfig = {
  key: 'saas',
  storage,
  blacklist: ['router'],
  timeout: undefined,
}

const loggerMiddleWare = (store: any) => (next: any) => (action: AnyAction) => {
  if (process.env.NODE_ENV !== 'production') console.log('[LOG] Action triggered', action)
  next(action)
}

export const history = createBrowserHistory()

const reducer = persistCombineReducers(persistConfig, {
  user: userReducer,
  dealership: dealershipReducer,
})

const store = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({ serializableCheck: false }),
    loggerMiddleWare,
    routerMiddleware(history),
  ],
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
